import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { OozieImportPage } from '@/features/workflows/oozie-import-page';

export const Route = createFileRoute('/$tenant/projects/$projectId/workflows/import-oozie')({
  component: ImportOozieRoute,
});

function ImportOozieRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="workflows"
      crumbs={[{ label: t('nav.items.workflows') }, { label: t('workflows.oozie.title') }]}
    >
      <OozieImportPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
